<script>
    import Pagination from 'vue/common/_pagination';
    import Utility from 'Utility';

    export default {
        components: {
            'pagination': Pagination
        },
        data() {
            return {
                loaded: false,
                resultsPerPage: 24
            };
        },
        methods: {
            defineSearch() {

                let queryString = Utility.getUrlQueryString();
                let $state = $('.state');
                let categoryState = $state.data('category');
                let brandState = $state.data('brand');

                // First, check if state from server exists

                if (categoryState) {
                    this.$emit('update-refinement', 'tree-menu', categoryState);
                    return;
                }

                // Second, check if brand from server is set

                if (brandState) {
                    this.$emit('update-refinement', 'brand', brandState);
                    return;
                }


                // Third, If there are no query string in the url, return

                if (!queryString) {
                    return;
                }

                // Fourth, if there is a query string, but there's only 1 param 'q' then search by using that query

                if (Utility.getParamCount() == 1) {
                    this.$emit('search-by-query');
                    return;
                }

                // Finally, If there is a query string, set the state from the query string

                this.$emit('update-state-by-url', queryString);

            },
            onPageChange() {
                let $page = $("html, body");

                $page.animate({scrollTop: 0}, 500);

                return false;
            }
        },
        mounted() {
            this.defineSearch();

            this.algolia.helper.once('result', ()=>{
                this.loaded = true;
            });
        },
        props: ['index','algolia']
    }
</script>
